import {FloteEndpointGroup} from "@/lib/api/endpoints/FloteEndpointGroup";

export class EntitiesApi extends FloteEndpointGroup {
    public relativeUri: string = "legal-entities";


}
